import CategoricalScheme from '../../CategoricalScheme';
import { ColorSchemeGroup } from '../../types';

const schemes = [
  {
    id: 'cryptodt',
    label: 'CryptoDT',
    group: ColorSchemeGroup.Featured,
    colors: [
      '#8a3ffc', // 1
      '#33b1ff',
      '#007479',
      '#ff7eb6',
      '#fa4d56', // 5
      '#fff1f1',
      '#6fdc8c', // 7
      '#4589ff',
      '#d12771',
      '#d2a106', // 10
      '#08bdba',
      '#bae6ff', // 12

      '#896fe0',
      '#4fa6e0',
      '#006e6a',
      '#e778a7',
      '#d95450', // 17
      '#f6dbdb',
      '#57b176',
      '#3a74d6',
      '#b52460',
      '#b3970a',
      '#069797',
      '#99bee1', // 24

      '#8a8ecf',
      '#66b4d9',
      '#00726f',
      '#cc7ba2',
      '#c5635c',
      '#f0d4d4',
      '#66a87f',
      '#4e7cc9',
      '#a53a5f',
      '#a2880c',
      '#0b9696',
      '#abc3df', // 36

      '#8b9bbf',
      '#79bad6',
      '#00807f',
      '#be7ca0',
      '#c57976',
      '#eac6c5',
      '#7a9f8b',
      '#5981be',
      '#9f4763',
      '#96860f',
      '#0e9c9c',
      '#aec6e1', // 48

      // traffic lights colors:

      '#FF5470', // 49
      '#FF8B38', // 50
      '#FFC530', // 51
      '#0284C7', // 52
      '#059669', // 53
    ],
  },
].map(s => new CategoricalScheme(s));

export default schemes;
